// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Anchors_wrapper__L_Glx","links":"Anchors_links__nOgud","link":"Anchors_link__Hp4kY","isActive":"Anchors_isActive__DvyQF"};